var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" asd "),_c('ol',{staticClass:"breadcrumb float-xl-end"},[_c('li',{staticClass:"breadcrumb-item active"},[_vm._v("Home")])]),_c('h1',{staticClass:"page-header"},[_c('i',{staticClass:"fab fa-delicious"}),_vm._v(" Home "),_c('small')])])
}]

export { render, staticRenderFns }